import Modal from 'javascripts/components/Modal';
import React from 'react';
import {render} from 'react-dom';

export default function($toggleEl) {
  const id = $toggleEl.attr('href');
  const $modalEl = $(id);

  // only mount one modal per unique Modal behavior (unique by href)
  if($(`${id}-react`).length) return true;

  $('body').append(
    `<span id="${id.split('#')[1]}-react"><span>`
  );

  render(
    <Modal
      containerClassName={$modalEl.data('modal-class')}
      disableClickOutsideToClose={$modalEl.data('disable-click-outside-to-close')}
      disableEscapeToClose={$modalEl.data('disable-escape-to-close')}
      disableHistory={$modalEl.data('disable-history')}
      modalId={id.replace('#', '')}
      modalInnerClassName={$modalEl.data('modal-inner-class-name')}
      onCloseCallback={eval($modalEl.data('on-close-callback'))}
      ref={el => window.modal.instances[id] = el}
    >
      <span dangerouslySetInnerHTML={{__html: $modalEl.html()}} />
    </Modal>,
    $(`${id}-react`)[0],
  );

  $toggleEl.on('click', (event) => {
    event.preventDefault();

    window.modal.toggle(
      $toggleEl.attr('href'),
    );
  });
}
